// src/components/MobilePagination.js
import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

const MobilePagination = ({ currentPage, totalPages, onPageChange }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 flex justify-between items-center sm:hidden">
      <button
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        className="flex items-center px-3 py-2 rounded-md bg-gray-100 disabled:opacity-50"
      >
        <ChevronLeftIcon className="h-5 w-5 mr-1" />
        Anterior
      </button>
      
      <span className="text-sm">
        Página {currentPage} de {totalPages}
      </span>
      
      <button
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        className="flex items-center px-3 py-2 rounded-md bg-gray-100 disabled:opacity-50"
      >
        Siguiente
        <ChevronRightIcon className="h-5 w-5 ml-1" />
      </button>
    </div>
  );
};

export default MobilePagination;